import { Phone, Send } from "lucide-react";
import { COMPANY } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

export default function MobileBar() {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/10 bg-black/92 backdrop-blur-md md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        data-testid="mobile-sticky-call-button"
        href={COMPANY.phoneHref}
        className="flex items-center justify-center gap-2 border-r border-white/10 py-4 font-mono text-xs uppercase tracking-[0.18em] text-white"
      >
        <Phone className="h-4 w-4 text-weld" />
        Ring
      </a>
      <button
        type="button"
        data-testid="mobile-sticky-quote-button"
        onClick={() => scrollToSection("#kontakt")}
        className="flex items-center justify-center gap-2 bg-white py-4 font-mono text-xs uppercase tracking-[0.18em] text-black"
      >
        <Send className="h-4 w-4" />
        Skicka förfrågan
      </button>
    </div>
  );
}
